<template>
  <div class="product-reservation-weekly-container">
    <div class="side-calendar">
      <div class="flex flex-center justify-center">
        <div class="flex-align" style="gap:0 12px">
          <i class="material-icons icon-arrow unselect" @click="clickPrev">keyboard_arrow_left</i>
          <div class="size-14 side-cal-title">{{ `${currentDate.year()}년 ${currentDate.month()+1}월` }}</div>
          <i class="material-icons icon-arrow unselect" @click="clickNext">keyboard_arrow_right</i>
        </div>
      </div>
      <div class="lp-dates">
        <div class="day-num unselect"
             :class="{'day-num-now': date.now, 'day-num-select': selectedDay && date.date_str === selectedDay.date_str}"
            v-for="(date,idx) in dates" :key="`day-${idx}`"
             @click="clickDay(date)">{{ date.day }}</div>
      </div>
    </div>
    <div class="main-calendar">
      <div class="grid-cal-title">
        <div>
          <button class="button button-now" @click="clickNow">오늘</button>
        </div>
        <!-- 연,월 -->
        <div class="flex flex-center justify-center">
          <div class="flex-align" style="gap:0 8px">
            <i class="material-icons icon-arrow unselect" @click="clickPrev">keyboard_arrow_left</i>
            <div class="size-18">{{ `${currentDate.year()}년 ${currentDate.month()+1}월` }}</div>
            <i class="material-icons icon-arrow unselect" @click="clickNext">keyboard_arrow_right</i>
          </div>
        </div>
        <div class="flex-end" style="gap:8px">
          <button class="button" style="width:72px" @click="initAll">
              <span class="flex-align" style="gap:4px">
                <svg width="12" height="14" viewBox="0 0 12 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M11.3333 2.75016H8.66667V2.0835C8.66667 1.55306 8.45595 1.04436 8.08088 0.669283C7.70581 0.29421 7.1971 0.0834961 6.66667 0.0834961H5.33333C4.8029 0.0834961 4.29419 0.29421 3.91912 0.669283C3.54405 1.04436 3.33333 1.55306 3.33333 2.0835V2.75016H0.666667C0.489856 2.75016 0.320286 2.8204 0.195262 2.94543C0.0702379 3.07045 0 3.24002 0 3.41683C0 3.59364 0.0702379 3.76321 0.195262 3.88823C0.320286 4.01326 0.489856 4.0835 0.666667 4.0835H1.33333V11.4168C1.33333 11.9473 1.54405 12.456 1.91912 12.831C2.29419 13.2061 2.8029 13.4168 3.33333 13.4168H8.66667C9.1971 13.4168 9.70581 13.2061 10.0809 12.831C10.456 12.456 10.6667 11.9473 10.6667 11.4168V4.0835H11.3333C11.5101 4.0835 11.6797 4.01326 11.8047 3.88823C11.9298 3.76321 12 3.59364 12 3.41683C12 3.24002 11.9298 3.07045 11.8047 2.94543C11.6797 2.8204 11.5101 2.75016 11.3333 2.75016ZM4.66667 2.0835C4.66667 1.90669 4.7369 1.73712 4.86193 1.61209C4.98695 1.48707 5.15652 1.41683 5.33333 1.41683H6.66667C6.84348 1.41683 7.01305 1.48707 7.13807 1.61209C7.2631 1.73712 7.33333 1.90669 7.33333 2.0835V2.75016H4.66667V2.0835ZM9.33333 11.4168C9.33333 11.5936 9.2631 11.7632 9.13807 11.8882C9.01305 12.0133 8.84348 12.0835 8.66667 12.0835H3.33333C3.15652 12.0835 2.98695 12.0133 2.86193 11.8882C2.7369 11.7632 2.66667 11.5936 2.66667 11.4168V4.0835H9.33333V11.4168Z" fill="#787878"/>
                </svg>
                <span style="size:13px;flex:1;color:#363636">초기화</span>
              </span>
          </button>
          <button class="button is-primary button-set" style="width: 103px"
                  @click="clickAdd">+ 일정 추가</button>
        </div>
      </div>
      <div class="week-calendar-wrapper" ref="week">
        <div class="grid-week-calendar cal-th">
          <div class="grid-item item-day">
            <div class="th-time"></div>
          </div>
          <div v-for="(item,idx) in weeks" :key="`week-day-${idx}`" class="item-day">
            <div class="grid-item th-day" :class="{'th-day-now': item.now}">
              <div><div>{{ days[idx] }}</div><b>{{ item.day }}일</b></div>
            </div>
          </div>
        </div>
        <div class="grid-week-calendar cal-td">
          <div class="grid-item item-day">
            <div class="td-time" v-for="(time, idx) in times" :key="`time-${idx}`">{{ time }}</div>
          </div>
          <div v-for="(dayItem, idx) in weeks" :key="`week-day-${idx}`" class="item-day">
            <div>
              <!-- 시간 30분단위 박스 -->
              <div class="td-day" v-for="(time, tidx) in times" :key="`td-day-${tidx}`" @click="clickTimeTd(dayItem, time)"></div>
            </div>

            <!-- 일정 -->
            <template v-if="dayItem.schedule">
              <div v-for="(sch, sidx) in dayItem.schedule" :key="`sch-${sidx}`"
                   class="item-sch-wrapper" :style="schStyle(sch)">
                <div class="item-sch unselect" @click.stop.prevent="clickTime(dayItem, sch)">
                  <div class="size-12">{{ sch.start_time.substring(0,5) + '~' + sch.end_time.substring(0,5) }}</div>
                  <div class="flex-align">
                    <div class="size-11 weight-700">
                      <template v-if="sch.stock_infinite">무한대</template>
                      <template v-else>{{ currencyNum(sch.stock) }}명</template>
                    </div>
                    <div class="day-ordered">{{ sch.ordered_count }}</div>
                  </div>
                </div>
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
    <modal-reserve-schedule ref="scheduleModal" :prod="prod"
                            :selectedDate="selectedDate"
                            :selectedTime="selectedStartTime"
                            :reservePrice="reservePrice"
                            :reservePolicy="reservePolicy"
                            :selectorStocks="selectorStocks"
                            @accept="onAccept"></modal-reserve-schedule>
    <modal-reserve-schedule-update ref="scheduleUpdateModal"
                                   :prod="prod"
                                   :selectedTime="selectedTime"
                                   :reservePrice="reservePrice"
                                   :reservePolicy="reservePolicy"
                                   @accept="onAccept"></modal-reserve-schedule-update>
  </div>
</template>

<script>
  import moment from 'moment'
  import ModalReserveSchedule from "./ModalReserveSchedule";
  import ModalReserveScheduleUpdate from "./ModalReserveScheduleUpdate";
  export default {
    name: 'ProductReservationWeekly',
    components: {ModalReserveScheduleUpdate, ModalReserveSchedule},
    props: {
      prod: {
        type: Object
      },
      propDate: {
        type: String
      },
      reservePolicy: {
        type: Object
      },
      reservePrice: {
        type: Array
      },
      selectorStocks: {
        type: Array
      }
    },
    created() {
      this.now = moment();
      this.currentDate = this.propDate ? moment(this.propDate) : moment();
      this.getDates();
    },
    data() {
      return {
        days: ['일','월','화','수','목','금','토'],
        dates: [],
        currentDate: '',
        selectedDay: undefined,
        selectedDate: undefined,
        selectedStartTime: undefined,
        selectedTime: undefined,
        now: '',
        monthWeeks: [],
        weeks: [],
      }
    },
    computed: {
      times() {
        let times = [];
        for(let i=0; i<=23; i++) {
          times = times.concat(['%02d:00'.format(i), '%02d:30'.format(i)]);
        }
        return times;
      }
    },
    methods: {
      initAll() {
        if(confirm('오늘 이후에 예약이 없는 모든 일정이 삭제됩니다.')) {
          this.$axios.delete(this.getUrl(`reservation/product/${this.prod.id}/schedule/init`)).then(()=> {
            this.toastStatus('일정이 초기화되었습니다.');
            this.getDates();
          }).catch(()=>{
            this.toastStatus('일정 초기화에 실패했습니다.');
          });
        }
      },
      onAccept() {
        this.getDates();
      },
      schStyle(sch) {
        let deco = {
          top: 0
        };
        let start = this.getTimeNum(sch.start_time);
        let end = this.getTimeNum(sch.end_time);
        deco.top = (this.getTimeNum(sch.start_time) * 13) + 'px';
        deco.height = ((end - start) * 13) + 'px';
        return deco;
      },
      getTimeNum(item) {
        let time = item.split(':');
        return (Number(time[0])*60 + Number(time[1]))/10;
      },
      clickNow() {
        this.currentDate = moment(this.now.format('YYYY-MM-DD'));
        this.getDates();
      },
      clickAdd() {
        this.selectedDate = undefined;
        setTimeout(()=>{
          this.$refs.scheduleModal.open();
        }, 100);
      },
      clickPrev() {
        this.currentDate.subtract(1, 'months');
        this.getDates();
      },
      clickNext() {
        this.currentDate.add(1, 'months');
        this.getDates();
      },
      clickDay(day) {
        this.selectedDay = day;
      },
      clickDate(date) {
        if(!date.before) {
          this.selectedDate = this.cloneItem(date);
          this.selectedStartTime = undefined;
          setTimeout(()=>{
            this.$refs.scheduleModal.open();
          }, 100);
        }
      },
      clickTimeTd(day, time) {
        this.selectedDate = this.cloneItem(day);
        this.selectedStartTime = time;
        setTimeout(()=>{
          this.$refs.scheduleModal.open();
        }, 100);
      },
      clickTime(dayItem,sch) {
        this.selectedTime = sch;
        this.selectedTime.org = dayItem.org;
        setTimeout(()=>{
          this.$refs.scheduleUpdateModal.open();
        }, 100);
      },
      getDates() {
        if(this.prod.id) {
          let year = this.currentDate.year();
          let month = this.currentDate.month()+1;
          this.$axios.get(this.getUrl(`reservation/product/${this.prod.id}/calendar/${year}/${month}`)).then(res => {
            this.dates = res.data;
            this.monthWeeks = [];
            for(let i=0; i < res.data.length/7; i++) {
              this.monthWeeks.push(res.data.slice(i*7, (i+1)*7))
            }
            this.selectedDay = this.dates.filter(i => i.day === this.currentDate.date())[0];
          });
        }
      },
    },
    watch: {
      selectedDay(n) {
        for(let week of this.monthWeeks) {
          if(week.some(i => i.day === n.day)) {
            this.weeks = week;
            break;
          }
        }
      },
      weeks(n) {
        this.$nextTick(()=>{
          let weeks = n.filter(i => i.schedule).reduce((a, c) => a.concat(
            c.schedule.map(i => {
              return this.getTimeNum(i.start_time) * 13;
            })
          ), []).sort();
          let top = weeks.length > 0 ? weeks[0] : 0;
          //this.$refs.week.scrollTo(0, top);
          this.$refs.week.scrollTo({
            left: 0,
            top: top,
            behavior: 'smooth'
          });
        })
      }
    }
  }
</script>

<style lang="stylus" scoped>
  $primary = #ff5722
  $c50 = #FFF0EB
  $c300 = #FFCEA6
  $c400 = #FF8C59
  $border = #dddddd

  .product-reservation-weekly-container
    display grid
    grid-template-columns 190px 1fr
    grid-column-gap 12px
    margin-top -28px
    margin-bottom -18px
  .side-calendar
  .main-calendar
    padding-top 18px

  .lp-dates
    margin-top 20px
    display grid
    grid-template-columns repeat(7, 1fr)
    gap 12px 0
  .day-num
    font-size 14px
    width 27px
    height 27px
    text-align center
    line-height 27px
  .day-num-now
    color $primary
    background-color $c50
    border-radius 100%

  .day-num-select
    color white
    background-color $primary
    border-radius 100%

  .side-cal-title
    font-size 14px
    font-weight 700
    color #4f4f4f
    background-color #f5f5f5
    border-radius 30px
    padding 4px 12px

  .grid-cal-title
    display grid
    grid-template-columns repeat(3, 1fr)
    margin-bottom 12px
    align-items center

  .button-now
    width 76px
  .button-set
    width 132px

  .main-calendar
    border-left 1px solid $border
    padding-left 12px


  .week-calendar-wrapper
    position relative
    margin-bottom 20px
    border 1px solid $border
    max-height 500px
    overflow-y scroll

  .cal-th
    position sticky
    top 0
    left 0
    width 100%
    background-color white
    z-index 1


  .grid-week-calendar
    display grid
    grid-template-columns 40px repeat(7, 1fr)
    .item-day
      position relative
      border-right 1px solid $border
    .item-day:last-child
      border-right 0

    .th-time
      border-bottom 1px solid $border
      height 48px

    .td-time
      text-align center
      background-color #f5f5f5
      color #787878
      font-size 12px

    .th-day
      height 48px
      text-align center
      display flex
      align-items center
      justify-content center
      border-bottom 1px solid $border
    .th-day-now
      color $primary

    .td-time
    .td-day
      height 39px
      border-bottom 1px solid $border

    .td-time:last-child
    .td-day:last-child
      border-bottom 0

  .cal-wrapper
    overflow-y scroll
    max-height 440px

  .day-ordered
    width 14px
    height 14px
    background-color #363636
    color white
    font-size 11px
    border-radius 2px
    margin-left 2px
    text-align center

  .item-sch-wrapper
    position absolute
    width 100%
    left 0
    padding 1px 1px 2px 1px

  .item-sch
    background-color $c300
    padding 2px 4px
    border-radius 4px
    width 100%
    height 100%
    .size-12
      line-height 14px

  .item-sch:hover
    background-color $c400

</style>
